module.exports = __webpack_public_path__ + "static/media/home_garden.fb60cbd0.jpg";